import React, { useState, useEffect } from 'react';
import {
  makeStyles,
  Grid,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  TextField,
} from '@material-ui/core';
import Card from '../../components/Card/Card';
import CardBody from '../../components/Card/CardBody';
import { search } from '../../dataService/search';

let queue;
const Filter = ({ searchTerms, setSearchTerms }) => {
  const classes = useStyles();
  const [packageStatus, setPackageStatus] = useState('Active');
  const [packageCode, setPackageCode] = useState('');

  useEffect(() => {
    const updatedSearchTerms = {
      ...searchTerms,
      ...{ 'status': packageStatus },
    };

    if (packageCode.length) {
      updatedSearchTerms['packageCode'] = packageCode;
    } else {
      delete updatedSearchTerms['packageCode'];
    }

    setSearchTerms(updatedSearchTerms);
  }, [packageStatus, packageCode]);

  useEffect(() => {
    const updatedSearchTerms = {
      ...searchTerms,
      ...{ 'status': packageStatus },
    };

    if (!packageCode) {
      delete updatedSearchTerms['packageCode'];
      setSearchTerms(updatedSearchTerms);
    }

    if (packageCode.length > 5) {
      updatedSearchTerms['packageCode'] = packageCode;
      clearTimeout(queue);
      queue = setTimeout(() => {
        setSearchTerms(updatedSearchTerms);
      }, 500);
    }
  }, [packageCode]);

  return (
    <Card>
      <CardBody>
        <h4 className={classes.filterTitle}>Search package Details</h4>
        <Grid container spacing={2}>
          <Grid md={4} item>
            <TextField
              value={packageCode}
              onChange={ev => setPackageCode(ev.target.value)}
              className={classes.fullWidth}
              label="Package Code"
              placeholder="PRM_ABS_TEST"
              variant="outlined"
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  );
};

const useStyles = makeStyles({
  topSpacing: {
    marginTop: '30px',
  },
  filterTitle: {
    margin: '0 0 15px 0',
  },
  marginNone: {
    margin: 0,
  },
  formControl: {
    '& legend': {
      margin: '0 200px 0 0',
    },
  },
  fullWidth: {
    width: '100%',
  },
  formGroup: {
    '& label': {
      margin: 0,
    },
  },
});

export default Filter;
